module.exports = __webpack_public_path__ + "img/link_f_img01.8c7776c6.gif";